import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { ForgotPasswordViewModel } from 'src/app/shared-core/models/auth-data.model';
import { AuthService } from 'src/app/shared-core/services/auth.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
})
export class ForgetPasswordComponent implements OnInit {
  constructor(private authService: AuthService) {}
  @Input() emailAddress: string;
  captcha: string;
  submitted: boolean;
  @Input() responseReceived: boolean;
  @Output() responseReceivedChange = new EventEmitter<boolean>();
  @Input() myModal: ModalDirective;
  @Input() loginModal: ModalDirective;
  @ViewChild('f', { static: false }) form: NgForm;
  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid || !this.captcha) {
      return;
    }
    let forgotPasswordViewModel = new ForgotPasswordViewModel();
    forgotPasswordViewModel.Email = this.form.value.email;

    this.authService.forgotpassword(forgotPasswordViewModel).subscribe((result) => {
      this.responseReceived = true;
      this.responseReceivedChange.emit(this.responseReceived);
      this.submitted = false;
      this.form.resetForm();
    });
  }
  ngOnInit(): void {
    this.captcha = '';
  }
}
